import { deleteWoundOrderOptions, type FullOrderViewModel } from '@generated';
import { OrderItems } from '~/features/orders/OrderItems';
import { useFullOrder } from '~/features/orders/orders/FullOrderContext';
import { useMutation } from '~/util/http/useMutation';
import { WoundOrderFormModal } from './WoundOrderFormModal';
import { useGetWoundOrders } from '../queries';
import { useSuspenseQuery } from '@tanstack/react-query';
import { WoundOrderRow } from './WoundOrderRow';

export function hasWoundOrders(fullOrder: FullOrderViewModel) {
	return fullOrder.woundOrders.length > 0;
}

export function WoundOrders() {
	const { fullOrder } = useFullOrder();
	const { refetch } = useSuspenseQuery(useGetWoundOrders(fullOrder.id));
	const deleteWoundOrder = useMutation({
		...deleteWoundOrderOptions,
		invalidateQueryKeys: []
	});

	return (
		<OrderItems
			title="Wound Orders"
			items={fullOrder.woundOrders.map(x => (
				<WoundOrderRow key={x.id} woundOrder={x} />
			))}
			sectionButtonProps={{
				label: 'Add Wound Order',
				useSuspense: true,
				actionType: 'add',
				renderModal: closeModal => <WoundOrderFormModal fullOrder={fullOrder} closeModal={closeModal} />
			}}
			// items={fullOrder.woundOrders.map(e => ({
			// 	id: e.id,
			// 	label: e.wound.woundLabel
			// }))}
			// addButtonProps={{
			// 	label: 'Add Wound Order',
			// 	useSuspense: true,
			// 	renderModal: closeModal => <StructuredWoundOrderFormModal stayId={fullOrder.stayId} orderId={fullOrder.id} closeModal={closeModal} />
			// }}
			// editButtonProps={{
			// 	label: 'Edit Wound Order',
			// 	renderModal: (id, closeModal) => <p>Modal to edit frequency</p>
			// }}
			// removeButtonProps={{
			// 	label: 'Remove Wound Order',
			// 	renderModal: (id, closeModal) => <p>Alert</p>
			// }}
		/>
	);

	// return (
	// 	<Section
	// 		header={<SectionHeader title="Wounds" />}
	// 		footer={
	// 			order.canBeEdited && (
	// 				<div className="flex items-center gap-2">
	// 					<Button
	// 						Icon={TextAlignJustify}
	// 						label="Add wound order"
	// 						intent="neutralLight"
	// 						appearance="outline"
	// 						size="sm"
	// 						useSuspense
	// 						renderModal={closeModal => (
	// 							<UnstructuredWoundOrderFormModal stayId={order.stayId} orderId={order.id} closeModal={closeModal} />
	// 						)}
	// 					/>
	// 					<Button
	// 						Icon={List}
	// 						label="Add wound order"
	// 						intent="neutralLight"
	// 						appearance="outline"
	// 						size="sm"
	// 						useSuspense
	// 						renderModal={closeModal => (
	// 							<StructuredWoundOrderFormModal stayId={order.stayId} orderId={order.id} closeModal={closeModal} />
	// 						)}
	// 					/>
	// 				</div>
	// 			)
	// 		}
	// 	>
	// 		{order.woundOrders.length > 0 &&
	// 			woundsAndOrders.map(x => (
	// 				<WoundAndOrder
	// 					key={x.wound.id}
	// 					wound={x.wound}
	// 					woundOrder={x.order}
	// 					renderWoundOrderChildren={woundOrder =>
	// 						order.canBeEdited ? (
	// 							<div className="flex items-center gap-1">
	// 								<Button
	// 									Icon={Pencil}
	// 									aria-label="Add wound order"
	// 									intent="neutralLight"
	// 									appearance="ghost"
	// 									size="xs"
	// 									renderModal={closeModal => (
	// 										<UnstructuredWoundOrderFormModal
	// 											stayId={order.stayId}
	// 											orderId={order.id}
	// 											woundOrder={woundOrder}
	// 											closeModal={closeModal}
	// 										/>
	// 									)}
	// 								/>
	// 								<Button
	// 									Icon={Trash2}
	// 									size="xs"
	// 									appearance="ghost"
	// 									intent="neutralLight"
	// 									aria-label="Remove goal"
	// 									renderModal={closeModal => (
	// 										<Prompt
	// 											title="Delete Order"
	// 											text="Are you sure you want to delete the order?"
	// 											onAction={() => {
	// 												deleteWoundOrder.mutateAsync({ woundOrderId: woundOrder.id });
	// 												closeModal();
	// 											}}
	// 											onCancel={closeModal}
	// 										/>
	// 									)}
	// 								/>
	// 							</div>
	// 						) : undefined
	// 					}
	// 				/>
	// 			))}
	// 	</Section>
	// );
}
